import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';

const BaseButton = styled(Button)(({}) => ({
    flex: '1',
    margin: '5px 0',
    padding: '12px 25px',
    minHeight: '45px',
    borderRadius: '50px',
    lineHeight: '1.25',
    fontSize: 'inherit',
    textTransform: 'none'
}));

const ThemedButton = styled(BaseButton)(() => ({
}));

const ThemedLinkButton = styled(Button)(({ theme }) => ({
    '&:hover': {
        backgroundColor: 'transparent',
    },
    '&:focus-visible': {
        outline: '3px solid ' + theme.palette.primary.main,
        outlineOffset: '2px',
    },
    color: theme.palette.mode === 'dark' && theme.palette.contrastDefault.main
}));

const CheckAvailabilityButton = styled(BaseButton)(({ theme }) => ({
    backgroundColor: theme.palette.tertiary.main,
    color: theme.palette.tertiary.contrastText,
    '&:hover': {
        backgroundColor: theme.palette.tertiary.dark
    },
    '&:focus-visible': {
        outline: '3px solid ' + theme.palette.primary.main,
        outlineOffset: '2px',
    }
}));

const WidgetButton = styled(BaseButton)(({ theme }) => ({
    display: 'flex',
    backgroundColor: theme.palette.tertiary.main,
    color: theme.palette.tertiary.contrastText,
    '&:hover': {
        backgroundColor: theme.palette.tertiary.dark,
        color: '#fff'
    },
    '&:focus-visible': {
        outline: '3px solid ' + theme.palette.primary.main,
        outlineOffset: '2px',
    }
}));

const MediaButton = styled(BaseButton)(({ theme }) => ({
    padding: '12px 35px',
    fontSize: '.75rem',
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.primary.main : theme.palette.tertiary.main,
    color: theme.palette.mode === 'dark' ? theme.palette.primary.contrastText : theme.palette.tertiary.contrastText,
    '&:hover': {
        backgroundColor: theme.palette.tertiary.dark,
        color: '#fff'
    },
    '&:focus-visible': {
        outline: '3px solid ' + theme.palette.primary.main,
        outlineOffset: '2px',
    },
    '& .MuiTouchRipple-root': {
        display: 'none'
    }
}));

const SearchIconButton = styled(IconButton)(({ theme }) => ({
    color: theme.palette.common.white,
    backgroundColor: theme.palette.common.black,
    boxShadow: '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)',
    transition: 'all .2s ease-in-out',
    height: '32px',
    width: '32px',
    '&:hover': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
    },
    '&:focus-visible': {
        outline: '3px solid ' + theme.palette.primary.main,
        outlineOffset: '2px',
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
}));

const QuickFindSearchButton = styled(BaseButton)(({ theme }) => ({
    width: 'fit-content',
    height: '100%',
    margin: '0',
    padding: '10px 25px',
    borderRadius: '0 50px 50px 0',
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary,
    boxShadow: '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 10%), 0px 1px 5px 0px rgb(0 0 0 / 10%)',
    fontSize: '13px'
}));

export {
    ThemedButton,
    ThemedLinkButton,
    CheckAvailabilityButton,
    WidgetButton,
    MediaButton, 
    SearchIconButton, 
    QuickFindSearchButton
};